import { Component } from 'react'
import { SelectableFeedFilter } from 'interfaces/feed'
import { SidebarGroupsItemColor } from 'components/features/pfm/SidebarGroups/SidebarGroupsItem'
import { Badge } from 'components/features/pfm/Badge/Badge'
import { SidebarGroupsItemChevron } from 'components/features/pfm/SidebarGroups/SidebarGroupsItemChevron'
import { AnalyticsEvent } from 'interfaces/analytics'
import { RelationId } from 'interfaces/peergroups'
import { SidebarGroupsItemPremiumWrapper } from 'components/features/pfm/SidebarGroups/SidebarGroupsItemPremiumWrapper'


export type FeedFilterMenuItemStateProps = {
  selectedFilter: SelectableFeedFilter | null
  shownPopupFilter: SelectableFeedFilter | null
  hidePopupTimeoutId: number | null
  hasNewPosts: boolean
  showChevron: boolean
}

export type FeedFilterMenuItemDispatchProps = {
  trackUIEvent: (event: AnalyticsEvent) => void
  onSelectFilter: (filter: SelectableFeedFilter) => void
  onShowPopup: (rect: ClientRect, filter: SelectableFeedFilter) => void
  onHidePopup: () => void
  onRegisterHidePopupTimeout: (timeoutId: number) => void
}

export type FeedFilterMenuItemOwnProps = {
  filter: SelectableFeedFilter
  color: SidebarGroupsItemColor
  text: string
  relationId: RelationId | 'member'
}

type FeedFilterProps =
  & FeedFilterMenuItemStateProps
  & FeedFilterMenuItemDispatchProps
  & FeedFilterMenuItemOwnProps

export class FeedFilterMenuItem extends Component<FeedFilterProps> {
  render () {
    const {
      filter,
      color,
      selectedFilter,
      shownPopupFilter,
      onHidePopup,
      hidePopupTimeoutId, onRegisterHidePopupTimeout,
      text,
      relationId,
    } = this.props

    const isSelected = this.areFiltersMatching(filter, selectedFilter)
    const isPopupShown = this.areFiltersMatching(filter, shownPopupFilter)

    return (
      <SidebarGroupsItemPremiumWrapper
        selected={ isSelected }
        selectable
        color={ color }
        isAnyPopupShown={ !!shownPopupFilter }
        isPopupShown={ isPopupShown }
        onSelect={ this.handleSelect }
        onShowPopup={ this.handleShowPopup }
        onHidePopup={ onHidePopup }
        hideTimeoutId={ hidePopupTimeoutId }
        onRegisterHideTimeout={ onRegisterHidePopupTimeout }
        icon={ this.renderIcon() }
        relationId={ relationId }
      >
        { text }
      </SidebarGroupsItemPremiumWrapper>
    )
  }

  private renderIcon () {
    const { hasNewPosts, showChevron } = this.props

    if (showChevron) {
      return (
        <SidebarGroupsItemChevron
          color={ hasNewPosts ? 'success' : 'satin' }
        />
      )
    }

    return hasNewPosts && (
      <Badge theme='success'>New</Badge>
    )
  }

  private areFiltersMatching (itemFilter: SelectableFeedFilter, optionalFilter: SelectableFeedFilter | null) {
    return !!optionalFilter
      && (
        optionalFilter.type === 'your-posts' && itemFilter.type === 'your-posts'
        || optionalFilter.type === 'feedgroup' && itemFilter.type === 'feedgroup' && optionalFilter.slug === itemFilter.slug
        || optionalFilter.type === 'peergroup' && itemFilter.type === 'peergroup' && optionalFilter.relationId === itemFilter.relationId
      )
  }

  private handleSelect = () => {
    const { filter, onSelectFilter, trackUIEvent, text } = this.props
    // `Anchor` event handling manages to hook the click event and destroy anchor without this timeout
    // https://tangle.atlassian.net/browse/SM-580
    setTimeout(() => {
      onSelectFilter(filter)
      trackUIEvent({
        category: 'site_controls-feed_filter',
        action: 'select',
        label: text,
      })
    }, 0)

  }

  private handleShowPopup = (rect: ClientRect) => {
    const { filter, onShowPopup } = this.props
    onShowPopup(rect, filter)
  }
}
